<template>
  <div class="about-tal-wrapper">
    <div class="about-tal-title">
      {{ config.title }}
    </div>
    <div class="about-tal-img" v-lazy-background :lazy-background="aboutTalBg" />
    <p class="about-tal-desc">
      {{ config.desc }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      aboutTalBg: require('assets/images/about-us/hk-about-tal.jpg'),
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.about-tal-wrapper {
  margin: 0 auto;
  padding: 60px 0 120px;
  width: 1240px;

  .about-tal-title {
    margin-bottom: 50px;
    font-size: 48px;
    font-weight: 600;
    color: var(--txt-color-lv1);
    line-height: 56px;
    text-align: center;
  }

  .about-tal-img {
    margin-bottom: 40px;
    width: 1240px;
    height: 293px;
    content: '';
    // background-image: url('~assets/images/about-us/hk-about-tal.jpg');
    background-size: 1240px 293px;
    background-repeat: no-repeat;
    border-radius: 18px;
  }

  .about-tal-desc {
    font-size: 24px;
    font-weight: 600;
    color: var(--txt-color-lv1);
    line-height: 33px;
  }
}
</style>
